import{b as H,c as y}from"./utils--8rlMPY4.js";const Y=o=>{const r=new Set;return o.forEach(t=>{const n=(t.products?t.products[0]:t).custom,l=(n==null?void 0:n.product_sets_top)||[],a=(n==null?void 0:n.products_sets_bottom)||[];[...l,...a].forEach(i=>{i.id&&r.add(i.id)})}),[...r]},Z=async o=>{var s,p;if(!o.length)return{};const r="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,[,e]=window.location.pathname.split("/"),l=((e||"").split("-")[1]||"gb").toUpperCase(),a=o.map(d=>`gid://shopify/Product/${d}`),i=`
    query GetSetProductPrices($ids: [ID!]!) @inContext(country: ${l}) {
      nodes(ids: $ids) {
        ... on Product {
          id
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;try{const c=await(await fetch(r,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:i,variables:{ids:a}})})).json(),h={};return(p=(s=c.data)==null?void 0:s.nodes)==null||p.forEach(u=>{if(u!=null&&u.id){const f=u.id.replace("gid://shopify/Product/","");h[f]=parseFloat(u.priceRange.minVariantPrice.amount)}}),h}catch(d){return console.error("Failed to fetch set product prices:",d),{}}},tt=async o=>{var l,a;if(!o.length)return{};const r="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,e=o.map(i=>`gid://shopify/Product/${i}`),n=`
    query GetCollaborationColors($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          collaborationColor: metafield(namespace: "magento", key: "color") {
            value
          }
        }
      }
    }
  `;try{const s=await(await fetch(r,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:n,variables:{ids:e}})})).json(),p={};return(a=(l=s.data)==null?void 0:l.nodes)==null||a.forEach(d=>{var h;const c=(h=d==null?void 0:d.collaborationColor)==null?void 0:h.value;d!=null&&d.id&&c&&(p[d.id.replace("gid://shopify/Product/","")]=c)}),p}catch(i){return console.error("Failed to fetch collaboration colours:",i),{}}},G=(o,r)=>{if(!r||!Object.keys(r).length)return null;const t=o.custom,e=(t==null?void 0:t.product_sets_top)||[],n=(t==null?void 0:t.products_sets_bottom)||[],l=[...e,...n];if(!l.length)return null;let a=1/0;return l.forEach(i=>{const s=r[i.id];s!==void 0&&s<a&&(a=s)}),a===1/0?null:a},W=o=>{if(!Array.isArray(o)||o.length===0)return"";const r=new Map;return o.forEach(t=>{const e=t==null?void 0:t.url,n=Number(t==null?void 0:t.width);!e||!Number.isFinite(n)||n<=0||r.has(n)||r.set(n,e)}),r.size===0?"":[...r.entries()].sort(([t],[e])=>t-e).map(([t,e])=>`${e} ${t}w`).join(", ")},B=(o,r)=>{var l;if(!Array.isArray(o)||o.length===0)return r||"";const t=o.filter(a=>(a==null?void 0:a.url)&&Number(a==null?void 0:a.width)>0);if(t.length===0)return((l=o[0])==null?void 0:l.url)||r||"";const e=600;return t.reduce((a,i)=>{const s=Math.abs(Number(a.width)-e);return Math.abs(Number(i.width)-e)<s?i:a}).url},ot=(o,{isSlide:r=!1,index:t=99,setProductPrices:e={},collaborationColors:n={}}={})=>{var C,A,T,F,I,V,j,N,z,M,q,x;const{key:l,title:a,link:i,imageInfo:s,sellingPrice:p,listPrice:d,custom:c,ticket:h}=o,u=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",f=((A=(C=s==null?void 0:s.images)==null?void 0:C[0])==null?void 0:A.sources)||[],E=B(f,s==null?void 0:s.thumbnail),m=W(f),O="(min-width: 1024px) 25vw, 50vw",g=(p==null?void 0:p.min)||0,w=(d==null?void 0:d.min)>(p==null?void 0:p.min)?d.min:0,b=(F=(T=c==null?void 0:c.product_hover_image)==null?void 0:T[0])==null?void 0:F.label,_=(V=(I=c==null?void 0:c.colour_count)==null?void 0:I[0])==null?void 0:V.label,$=(N=(j=c==null?void 0:c.collaboration_name)==null?void 0:j[0])==null?void 0:N.label,k=H((M=(z=c==null?void 0:c.collaboration_link)==null?void 0:z[0])==null?void 0:M.label),S=n[l],v=/^#[0-9a-f]{3,8}$/i.test(S||"")?` style="--collaboration-tag-color: ${S};"`:"",D=t<=2?"eager":"lazy",L=t<=2?"high":"auto",P=((q=c==null?void 0:c.product_sets_top)==null?void 0:q.length)>0||((x=c==null?void 0:c.products_sets_bottom)==null?void 0:x.length)>0?G(o,e):null;return`
    <${r?"li":"div"}
      class="product-card ${r?"splide__slide":""}"
      data-voyado-product
      data-product-key="${l}"
      data-product-ticket="${h}"
    >
      ${X(c,g,w)}
      ${U(o)}
      <a
        href="${u}${i}"
        class="product-card__image-container ${b?"has-hover":""}"
        aria-label="${a}"
      >
        <img
          src="${E}"
          ${m?`srcset="${m}" sizes="${O}"`:""}
          alt="Image of ${a}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${D}"
          fetchpriority="${L}"
        />
        ${b?`
          <img
            src="${b}"
            alt="Secondary image of ${a}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <div class="product-card__title-wrapper">
          <a href="${u}${i}" aria-label="${a}" class="product-card__title f1-lc">${a}</a>
          ${$?k?`<a href="${k}" class="product-card__collaboration f2-uc"${v}>${$}</a>`:`<p class="product-card__collaboration f2-uc"${v}>${$}</p>`:""}
        </div>
        ${P!==null?J(P):R(g,w)}
      </div>
       <p
        data-product-id="${l}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${_&&_>1?`
        <p class="product-card__colour-count f2-lc">
          ${_} Colours
        </p>
      `:""}
    </${r?"li":"div"}>
  `},J=o=>`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">
        From ${y(o)}
      </span>
    </div>`,R=(o,r)=>{let t="",e="product-card__price--current";return r&&(t=`
      <span class="product-card__price--original f1-lc">
        ${y(r)}
      </span>
    `,e="product-card__price--discounted"),`
    <div class="product-card__price">
      ${t}
      <span class="${e} f1-lc">
        ${y(o)}
      </span>
    </div>`},X=(o,r,t)=>{if(r&&t&&r<t)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-r/t)*100)}% OFF
      </p>
    `;const e=l=>{var i,s;const a=(s=(i=o==null?void 0:o[l])==null?void 0:i[0])==null?void 0:s.label;return a&&!a.includes("-")?a:""},n=e("stock")||e("petite")||e("collection")||e("new")||e("back_in_stock")||e("available_to_rent")||e("nc_exclusive");return n?`
      <p class="product-card__label product-label product-label--default">
        ${n}
      </p>
    `:""},U=o=>{var t;const r=((t=o.link)==null?void 0:t.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${o.key}"
      data-product-handle="${r}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{tt as a,ot as b,Y as c,Z as f};
